





















import { defineComponent, ref, onMounted } from '@vue/composition-api';
import Message from './message.vue';
export default defineComponent({
  components: {
    Message,
  },
  setup(props, { root, emit }: any) {
    console.log(props, { root, emit });
    const messageList = ref([]);
    const unread = ref(0);
    const getCommunicateList = async () => {
      const { err, data, sumUnread } = await root.$http.post('/hospital/getCommunicateList', {
        currentPage: 0,
        pageSize: 8,
        queryCount: true,
        lastSize: 0,
      });
      if (!err && data?.length) {
        messageList.value = data;
        unread.value = sumUnread;
      }
    };
    const jumpGroupMessage = (messageItems) => {
      if (messageItems.unread) {
        const newUnread = unread.value - messageItems.unread;
        unread.value = newUnread < 0 ? 0 : newUnread;
      }
      emit('remindClose');
      let path = '/default/groupMessage';
      if (messageItems) {
        path += `?id=${messageItems.id}&patientId=${messageItems.patientId || ''}&groupId=${
          messageItems.groupId || ''
        }&name=${messageItems.name || ''}`;
      }
      root.$router.replace({
        path,
      });
    };

    const itemsClick = (messageItems) => {
      jumpGroupMessage(messageItems);
    };
    onMounted(() => {
      getCommunicateList();
    });
    return {
      unread,
      messageList,
      jumpGroupMessage,
      itemsClick,
      getCommunicateList,
    };
  },
});
